export const BookingPrivateSources = {
  BANK_TRANSFER: "bank_transfer",
  CASH: "cash",
  VOUCHER: "voucher",
  OTHER: "other"
};
